module.exports = __webpack_public_path__ + "static/eastwood-fatal-error-775b166741f6ef7cd734b459f0fbb8de.svg";